<template>
  <div class="wrapper app-content">
    <div class="tilte-text"> 我的推广位 </div>
    <div class="desc"> 您创建电影票专属推广链接时，需要关联您的推广位。推广位用于记录您投放于不同渠道的影票推广链接转化效果 </div>
    <div class="create-btn-wrapper">
      <span class="create-btn" @click="addManage">
        <Icon type="md-add" size="16" />添加推广位
      </span>
    </div>
    <div class="table-wrapper">
      <Table border :columns="columns" :data="list" :loading="listLoading" :row-class-name="rowClassName">
        <template slot-scope="{ row }" slot="name">
          {{ row.name }}
        </template>
        <template slot-scope="{ row }" slot="config_type">
          <div class="status-text-success" @click="handleFuzzySet(row)">
            <div v-if="row.config_type === 1 || row.config_type === 0">
              <div v-if="row.config_type === 1">市场价比例{{row.rate_price
                }}%</div>
              <div v-if="row.config_type === 0">固定金额{{row.fix_price
                }}</div>
            </div>
            <span v-else>请设置</span>
          </div>
        </template>
        <template slot-scope="{ row }" slot="inquiry_discount_float">
          <span class="status-text-success" style="cursor: pointer;" @click="handelDiscountFloat(row)">{{ row.inquiry_discount_float ? row.inquiry_discount_float : '0' }}%</span>
        </template>
        <template slot-scope="{ row }" slot="status">
          <span class="status-text-success" v-if="row.status == 1">正常</span>
          <span class="status-text-reject" v-else>禁用</span>
        </template>
        <template slot-scope="{ row}" slot="action">
          <span class="show-excel" @click="getLink(row)">获取链接</span>
          <span class="show-excel" @click="toReport(row)">查看报表</span>
          <span class="show-excel" @click="editManage(row)">修改</span>
        </template>
      </Table>
      <div style="padding: 10px 0px">
        <Page :total="total" :current="searchForm.page" show-sizer show-elevator show-total @on-change="changePage"
          @on-page-size-change="changePagesize"></Page>
      </div>
    </div>
    <add-manage ref="AddManage" @refreshList="getList(true)" />
    <get-linked ref="GetLinked" @refreshList="getList(true)" />
    <discountFloatPop ref="discountFloatPopRef" @refresh="getList(false)"></discountFloatPop>
    <fuzzySet ref="fuzzySetRef" @refresh="getList(true)"></fuzzySet>
  </div>
</template>
<script>
import { Icon, Table, Page, Tooltip } from 'view-design'
import questionBtn from '@/assets/img/promotion/btn_doubt.png'
import AddManage from '@/views/pc/promotion/manage/modal/AddManage'
import GetLinked from '@/views/pc/promotion/manage/modal/GetLinked'
import Vue from 'vue'
import discountFloatPop from '@/views/pc/promotion/manage/modal/discountFloatPop'
Vue.component('Tooltip', Tooltip)
import { getPromotionList } from '@/api/promotion'
import fuzzySet from '@/views/pc/promotion/manage/modal/fuzzySet'
export default {
  name: 'PromotionManage',
  components: {
    Icon,
    Table,
    AddManage,
    GetLinked,
    Page,
    discountFloatPop,
    fuzzySet
  },
  data: function () {
    return {
      columns: [
        {
          title: '推广位名称',
          key: 'app_name',
          minWidth: 30
        },
        {
          title: 'AppKey',
          key: 'app_key',
          minWidth: 30
        },
        {
          title: '接口密钥AppSecret',
          key: 'app_secret',
          minWidth: 260,
          renderHeader: (h, params) => {
            return h('Tooltip', {
              props: {
                transfer: true,
                placement: 'bottom-end',//下右
              }
            }, [
              h('span', {
                slot: 'content',
                style: {
                  whiteSpace: 'normal'
                }
              }, '接口密钥是在订单推送中对推送数据进行加密用的。在订单读取中是接口用来判断网站主身份的。'),
              h('div', [
                h('span', {
                  domProps: {
                    innerHTML: '接口密钥appSecret'
                  }
                }),
                h('img', {
                  attrs: {
                    src: questionBtn
                  },
                  style: {
                    width: '25px'
                  }
                })
              ])
            ])
          },
          width: 260
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 50
        },
        {
          title: 'api调用权限',
          key: 'api_auth_str',
          minWidth: 50
        },
        {
          title: '截图询价报价浮动',
          key: 'inquiry_discount_float',
          slot: 'inquiry_discount_float',
          minWidth: 100,
          renderHeader: (h, params) => {
            return h('Tooltip', {
              props: {
                transfer: true,
                placement: 'bottom-end',//下右
              }
            }, [
              h('span', {
                slot: 'content',
                style: {
                  whiteSpace: 'normal'
                }
              }, '仅针对电商店铺截图询价模式生效。'),
              h('div', [
                h('span', {
                  domProps: {
                    innerHTML: '截图询价报价浮动'
                  }
                }),
                h('img', {
                  attrs: {
                    src: questionBtn
                  },
                  style: {
                    width: '25px'
                  }
                })
              ])
            ])
          },
        },
        {
          title: '截图询价纠错下单可亏损设置',
          key: 'config_type',
          slot: 'config_type',
          minWidth: 120
        },
        {
          title: '状态',
          key: 'status',
          slot: 'status',
          minWidth: 50
        },
        {
          title: '操作',
          slot: 'action',
          width: 200,
          align: 'center',
          minWidth: 200
        }
      ],
      list: [],
      listLoading: false,
      total: 0,
      searchForm: {
        page: 1,
        pagesize: 10,
      },
    }
  },
  created() {
    this.getList(true)
  },
  methods: {
    handleFuzzySet(row) {
      this.$refs.fuzzySetRef.init(2,row)
    },
    getList(first = false) {
      this.listLoading = true
      if (first) this.searchForm.page = 1
      getPromotionList(this.searchForm).then((response) => {
        this.listLoading = false
        if (response.code != 200) {
          this.$Message.error(response.msg)
          return
        }
        this.list = response.data.list
        this.total = response.data.total
        console.log(this.list,'this.list')
      })
    },
    handelDiscountFloat(row) {
      this.$refs.discountFloatPopRef.init(row)
    },
    rowClassName: function (row, index) {
      return index % 2 === 0 ? 'bg-fa' : 'bg-white'
    },
    // 获取链接
    getLink: function (row) {
      this.$refs.GetLinked.init(true, row)
    },
    addManage: function () {
      this.$refs.AddManage.init(true, {})
    },
    editManage: function (row) {
      this.$refs.AddManage.init(false, row)
    },
    changePage(value) {
      this.searchForm.page = value
      this.getList()
    },
    changePagesize(value) {
      this.searchForm.pagesize = value;
      //如果处于第一页改变数量，则会触发changePage
      if (this.searchForm.page == 1) {
        this.getList()
      }
    },
    toReport(row) {
      this.$store.dispatch('nav/changePromotionActiveIndex', 2)
      this.$router.push({ path: '/pc/promotion/report', query: { app_key: row.app_key } })
    },
  }
}
</script>
<style scoped>
.wrapper {
  width: 100%;
}

.wrapper .desc {
  margin-top: 20px;
  font-size: 14px;
  color: #666;
}

.wrapper .tilte-text {
  font-size: 20px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.wrapper .create-btn-wrapper {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.58rem;
}

.wrapper .create-btn-wrapper .create-btn {
  background: #ffffff;
  border: 1px solid #ff8622;
  border-radius: 2px;
  color: #ff8622;
  display: inline-block;
  font-size: 16px;
  padding: 0.18rem 0.44rem;
  cursor: pointer;
}

.wrapper .table-wrapper {
  margin-top: 0.62rem;
}

.table-wrapper .show-excel {
  font-size: 14px;
  color: #ff4f76;
  cursor: pointer;
  display: inline-block;
  padding-right: 7px;
}

.table-wrapper .show-excel:last-child {
  padding-right: 0px;
}

.table-wrapper .status-text-success {
  font-size: 14px;
  color: #3d9efc;
}

.table-wrapper .status-text-reject {
  font-size: 14px;
  color: #ff8622;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/promotion/manage/Index.vue